module.exports = __webpack_public_path__ + "img/default-role.06601a17.png";